import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import createDetectElementResize from './detectElementResize';
export default {
  name: 'AutoSizer',
  props: {
    unitKey: {
      type: String,
      required: true
    },
    onResize: {
      type: Function,
      default: null
    },
    nonce: {
      type: String,
      default: ''
    },
    disableHeight: {
      type: Boolean,
      default: false
    },
    disableWidth: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      detectElementResize: null,
      state: {
        height: 0,
        width: 0
      }
    };
  },
  computed: {},
  mounted: function mounted() {
    var nonce = this.nonce,
        onResizeCB = this.onResizeCB,
        $el = this.$el;
    this.detectElementResize = createDetectElementResize(nonce, window);
    this.detectElementResize.addResizeListener($el, onResizeCB);
    onResizeCB();
  },
  beforedestory: function beforedestory() {
    var detectElementResize = this.detectElementResize,
        $el = this.$el,
        onResizeCB = this.onResizeCB;

    if (detectElementResize && $el) {
      detectElementResize.removeResizeListener($el, onResizeCB);
    }
  },
  methods: {
    onResizeCB: function onResizeCB() {
      var disableHeight = this.disableHeight,
          disableWidth = this.disableWidth,
          onResize = this.onResize,
          unitKey = this.unitKey,
          state = this.state;
      var parentNode = this.$el;

      if (parentNode) {
        var height = parentNode.offsetHeight || 0;
        var width = parentNode.offsetWidth || 0;
        var style = window.getComputedStyle(parentNode) || {};
        var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(style.paddingRight, 10) || 0;
        var paddingTop = parseInt(style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
        var newHeight = height - paddingTop - paddingBottom;
        var newWidth = width - paddingLeft - paddingRight;

        if (!disableHeight && state.height !== newHeight || !disableWidth && state.width !== newWidth) {
          state.height = newHeight;
          state.width = newWidth;

          if (onResize) {
            onResize(unitKey, state);
          }
        }
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var slots = this.$slots.default || [];
    var height = this.state.height;
    return h("div", _mergeJSXProps([{}, {
      attrs: {
        'data-auto-height': "".concat(height)
      },
      class: {
        'ux-auto-sizer': true
      }
    }]), [slots]);
  }
};